import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Enrollment } from './enrollment.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class EnrollmentService extends AbstractEntityService {

    protected resourceUrl = 'api/enrollments';
    private resourceSearchUrl = 'api/_search/enrollments';
    protected resourceCountUrl = 'api/_search/count/enrollments';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(enrollment: Enrollment): Observable<Enrollment> {
        let copy: Enrollment = Object.assign({}, enrollment);
        copy.validUntil = this.dateUtils
            .convertLocalDateToServer(enrollment.validUntil);
        copy.validSince = this.dateUtils
            .convertLocalDateToServer(enrollment.validSince);
        return this.http.post<Enrollment>(this.resourceUrl, copy).map((res: Enrollment) => {
            return res;
        });
    }

    update(enrollment: Enrollment): Observable<Enrollment> {
        let copy: Enrollment = Object.assign({}, enrollment);
        copy.validUntil = this.dateUtils
            .convertLocalDateToServer(enrollment.validUntil);
        copy.validSince = this.dateUtils
            .convertLocalDateToServer(enrollment.validSince);
        return this.http.put<Enrollment>(this.resourceUrl, copy).map((res: Enrollment) => {
            return res;
        });
    }

    find(id: number): Observable<Enrollment> {
        return this.http.get<HttpResponse<Enrollment>>(`${this.resourceUrl}/${id}`).map((res: HttpResponse<Enrollment>) => {
            let jsonResponse = res.body;
            jsonResponse.validUntil = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.validUntil);
            jsonResponse.validSince = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.validSince);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<Enrollment[]>> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: HttpResponse<Enrollment[]>) => this.convertResponse(res));
    }

    search(req?: any): Observable<HttpResponse<Enrollment[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Enrollment[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<Enrollment[]>) => this.convertResponse(res));
    }

    private convertResponse(res: HttpResponse<Enrollment[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].validUntil = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].validUntil);
            jsonResponse[i].validSince = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].validSince);
        }
        return res.clone({body: jsonResponse});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment.service.ts